export default __webpack_public_path__ + "static/media/place-holder-image-master.de6ebea0.svg";